import axiosInstance, { getApiErrorMessage } from "../auth/apiConfig";

/**
 * @param {object} params
 * @param {number} params.opIpType - 0 = OP, 1 = IP
 * @param {string} [params.firstName]
 * @param {string} [params.lastName]
 * @param {number} [params.regNo]
 * @param {string} [params.fromDt] - YYYY-MM-DD
 * @param {string} [params.toDt] - YYYY-MM-DD
 * @param {boolean} [params.isDischarged]
 * @param {boolean} [params.isMlc]
 */
export const getOpIpPatients = async (params) => {
  try {
    const response = await axiosInstance.get("/api/v1/op-ip-patients", {
      params,
    });
    return response.data?.data ?? [];
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load patients"));
  }
};

/**
 * Maps OP/IP patient API row to the admission-row shape used by Dr Round UI.
 */
export const mapOpIpPatientToAdmissionRow = (row) => {
  const isDischarged = Boolean(row.isDischarged);
  return {
    admissionId: row.admVitId,
    regId: row.regId,
    status: isDischarged ? "Discharged" : "Admitted",
    uhid: row.regNoWithPrefix || "",
    patientName: row.patientName || "",
    contact: "",
    gender: "",
    age: row.ageYear != null ? String(row.ageYear) : "",
    admDateTime: [row.admVitDate, row.admVitTime].filter(Boolean).join(" "),
    doctorName: row.admDoctorName || "",
    doctorId: row.doctorId,
    refDocName: "",
    wardName: "",
    bedNo: "",
    tariffName: row.tariffName || "",
    admDate: row.admVitDate || "",
    departmentName: row.departmentName || "",
    ipOpNumber: row.ipOpNumber || "",
    isDischarged,
  };
};
